import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../AuthContext";
import GoogleButton from "../components/GoogleButton";
import AppHeader from "../components/AppHeader";
import SiteFooter from "../components/SiteFooter";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setLoading(true);
    try {
      await register(email.trim().toLowerCase(), password, name.trim());
      navigate("/app", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Could not create account."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page signup-page" data-testid="register-page">
      <div className="grain-bg" />
      <div className="container-narrow">
        <AppHeader />
        <div className="fade-in" style={{ maxWidth: 420, margin: "0 auto" }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Begin</div>
          <h1 className="display">Create your space.</h1>
          <p
            className="serif-italic"
            style={{ fontSize: 17, color: "var(--accent)", lineHeight: 1.6, marginBottom: 32 }}
          >
            One reframe a day, free. Save them all in your private journal.
          </p>

          <form onSubmit={handleSubmit} className="form-stack" data-testid="register-form">
            <div>
              <label className="field-label" htmlFor="name">Name (optional)</label>
              <input
                id="name" type="text" value={name}
                onChange={(e) => setName(e.target.value)}
                className="input-line" placeholder="What should we call you?"
                data-testid="register-name-input" autoComplete="name"
              />
            </div>
            <div>
              <label className="field-label" htmlFor="email">Email</label>
              <input
                id="email" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-line" placeholder="you@example.com"
                data-testid="register-email-input" autoComplete="email"
              />
            </div>
            <div>
              <label className="field-label" htmlFor="password">Password</label>
              <input
                id="password" type="password" required minLength={6}
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="input-line" placeholder="At least 6 characters"
                data-testid="register-password-input" autoComplete="new-password"
              />
            </div>

            {error && <div className="error-msg" data-testid="register-error">{error}</div>}

            <div style={{ paddingTop: 8 }}>
              <button type="submit" className="btn-underline" disabled={loading} data-testid="register-submit-btn">
                {loading ? "Creating…" : "Create account →"}
              </button>
            </div>
          </form>

          <div
            data-testid="register-privacy-note"
            className="serif-italic"
            style={{ fontSize: 15, fontWeight: 500, color: "var(--muted)", marginTop: 20, lineHeight: 1.6 }}
          >
            Your reframes are yours alone. Always private. Never shared.
          </div>

          <div className="auth-divider">or</div>

          <GoogleButton>Continue with Google</GoogleButton>

          <div style={{ marginTop: 36, textAlign: "center", color: "var(--muted)", fontSize: 13 }}>
            <span className="serif-italic">Have an account? </span>
            <Link to="/login" className="nav-link" data-testid="goto-login" style={{ display: "inline" }}>
              Sign in
            </Link>
          </div>
        </div>
        <SiteFooter />
      </div>
    </div>
  );
}
